
export type Rgb = readonly [number, number, number];

const WATER_BASE: Rgb = [29, 63, 102];
const WATER_WAVE: Rgb = [9, 14, 18];

/** The phase used by the GL water shader, exposed for the 2D fallback tests. */
export function waterWaveAt(worldXM: number, worldYM: number, timeSeconds: number): number {
  return (
    Math.sin(worldXM * 1.6 + timeSeconds * 1.05) *
      Math.sin(worldYM * 1.27 - timeSeconds * 0.83) +
    0.5 * Math.sin((worldXM + worldYM) * 0.71 + timeSeconds * 1.6)
  );
}

/** Return a blue, subtly changing water colour for one world cell. */
export function waterSurfaceColour(worldXM: number, worldYM: number, timeSeconds: number): Rgb {
  const wave = waterWaveAt(worldXM, worldYM, timeSeconds);
  return [
    channel(WATER_BASE[0] + WATER_WAVE[0] * wave),
    channel(WATER_BASE[1] + WATER_WAVE[1] * wave),
    channel(WATER_BASE[2] + WATER_WAVE[2] * wave),
  ];
}

function channel(value: number): number {
  return Math.round(Math.max(0, Math.min(255, value)));
}
